import React, { useState } from "react";

import { IoMdBookmarks } from "@react-icons/all-files/io/IoMdBookmarks";
import { RiTimerFill } from "@react-icons/all-files/ri/RiTimerFill";
import { RiEdit2Fill } from "@react-icons/all-files/ri/RiEdit2Fill";
import { AiOutlinePlus } from "@react-icons/all-files/ai/AiOutlinePlus";

import { Link } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import Loadingnovel from "../../../components/Loadingnovel";
import moment from "moment";

import { useSelector } from "react-redux";
function UserNovel({
  id,
  novel,
  setNovelChapsU,
  setChecked,
  setGetNovelId,
  setDeletePopUp,
  setUpdatePopUp,
  setNovelDataU,
}) {
  // get chapters of current novel
  const chapters = useSelector((state) => state.novelsChaps.novelChapters);
  const currentNovelChapters = chapters.filter(
    (chapter) => chapter.Novel_id === novel._id
  );

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
    delay: 100,
  });
  const [Delete, setDelete] = useState(false);

  function handleClickUpdate() {
    setNovelDataU({
      title: novel.title,
      description: novel.description,
      selectedFile: novel.selectedFile,
      tags: novel.tags,
    });
    setNovelChapsU(currentNovelChapters);
    setChecked(novel.tags);
    setUpdatePopUp(true);
    setGetNovelId(id);
  }

  function handleClickDelete() {
    setDeletePopUp(true);
    setGetNovelId(id);
  }
  return (
    <div ref={ref} className="z-10 relative">
      <Link to={`/novels/${novel._id}`}>
        <div
          className={
            Delete
              ? "group cursor-pointer p-0 sm:p-[6px] relative novel-hover max-h-auto w-full bg-error duration-500 ease-in-out"
              : "group cursor-pointer p-0 sm:p-[6px] relative novel-hover max-h-auto w-full bg-primary duration-500 ease-in-out"
          }
        >
          <div className="image-effect">
            {inView ? (
              <div className="rectangle  w-full h-full group-hover:scale-110 group-hover:opacity-80 duration-500 ease-in-out object-cover">
                {novel.selectedFile ? (
                  <img
                    className={
                      Delete
                        ? "rectangle opacity-80 scale-110 w-full h-full group-hover:scale-110 group-hover:opacity-80 duration-500 ease-in-out object-cover"
                        : "rectangle w-full h-full group-hover:scale-110 group-hover:opacity-80 duration-500 ease-in-out object-cover"
                    }
                    src={novel.selectedFile}
                    alt={novel.title}
                  />
                ) : (
                  <div className="flex justify-center items-center bg-secondary opacity-20 rectangle duration-[0] ease-in-out object-cover">
                    <Loadingnovel />
                  </div>
                )}
              </div>
            ) : (
              <div className="flex justify-center items-center bg-secondary opacity-20 rectangle duration-[0] ease-in-out object-cover">
                <Loadingnovel />
              </div>
            )}
            <div
              className={
                Delete
                  ? "absolute text-tertiary sm:group-hover:top-0 top-0 sm:-top-10 duration-500 ease-in-out flex justify-center items-center w-fit px-4 h-[32px] bg-error  space-x-[4px] font-SoraR"
                  : "absolute text-tertiary sm:group-hover:top-0 top-0 sm:-top-10 duration-500 ease-in-out flex justify-center items-center w-fit px-4 h-[32px] bg-primary  space-x-[4px] font-SoraR"
              }
            >
              <IoMdBookmarks />
              <span className="text-[14px] sm:text[16px]">
                {currentNovelChapters
                  ? currentNovelChapters.length < 10
                    ? "00" + currentNovelChapters.length
                    : currentNovelChapters.length > 99
                    ? currentNovelChapters.length
                    : "0" + currentNovelChapters.length
                  : "000"}
              </span>
            </div>
            <div className="absolute text-primary -bottom-10 sm:group-hover:bottom-0 sm:-bottom-10 group-hover:bottom-0 duration-500 ease-in-out right-0 flex justify-center items-center w-fit px-4 h-[32px] bg-tertiary space-x-[8px] uppercase font-SoraR">
              <RiTimerFill className="flex-none" />
              <span className="text-primary font-SoraR text-[10px] sm:text-[13px] line-clamp-1 break-all w-full">
                {moment(novel.createdAt).fromNow()}
              </span>
            </div>
          </div>
          <div className="mt-0 sm:mt-[12px] p-4 sm:p-0 mb-0 sm:mb-[8px] space-y-0 sm:space-y-[6px]">
            <div className="line-clamp-1">
              <h2 className="text-tertiary break-all  text-center sm:text-left capitalize text-[14px] sm:pb-0 pb-0 sm:text-[16px] font-SoraR">
                {novel.title}
              </h2>
            </div>
            <div className="w-full   h-[0.5px] hidden sm:block bg-tertiary/20"></div>
            <div className="line-clamp-2">
              <p className="text-tertiary break-all hidden sm:block capitalize  text-[13px] font-SoraL   ">
                {novel.description}
              </p>
            </div>
          </div>
        </div>
      </Link>
      <div className="rectangle w-full gap-2  md:gap-4 mt-2 md:mt-4 flex h-[52px]">
        <div onClick={handleClickUpdate} className="w-[70%] md:w-[80%]">
          <button className="rectangle flex justify-center items-center flex-row-reverse gap-x-4 Purple-btn-effect font-SoraR hover:bg-primary/90 w-full h-full bg-primary relative text-tertiary duration-300 ease-in-out">
            <span className="hidden sm:block">Update</span>
            <RiEdit2Fill />
          </button>
        </div>

        <div onClick={handleClickDelete} className="w-[30%] md:w-[25%]">
          <button
            onMouseEnter={() => setDelete(true)}
            onMouseLeave={() => setDelete(false)}
            className="rectangle  flex justify-center items-center font-SoraR hover:bg-error/90 w-full h-full bg-error relative text-tertiary duration-300 ease-in-out"
          >
            <AiOutlinePlus className=" text-tertiary scale-125 rotate-45" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default UserNovel;
